import { Pencil } from 'lucide-react';
import { useState } from 'react';

import { toast } from '@/hooks/use-toast';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import TradeMenuButton from './trade-menu-button';

const TradeMenu = () => {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <DropdownMenu open={open} onOpenChange={setOpen}>
        <DropdownMenuTrigger asChild>
          {/* <div>
            <DealMenuButton onClick={() => setOpen(true)} />
          </div> */}
          <div>
            <TradeMenuButton onClick={() => {}} />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
          align="start"
          side="bottom"
          sideOffset={4}
        >
          <DropdownMenuItem className="flex flex-row gap-2 items-center">
            <div
              className="flex flex-row gap-2 items-center"
              onClick={() => {
                toast({
                  title: 'Trade In Appraisal Menu Not Implemented',
                  description:
                    'Request for this feature over slack. Let us know what commands and actions you want to see.',
                });
              }}
            >
              <Pencil className="size-3" />
              <div className="flex flex-col text-nowrap truncate">
                <p className="text-xs">More Actions soon!</p>
                {/* <p className="text-xs text-muted-foreground">{tradeIn.vin}</p> */}
              </div>
            </div>

            {/* <DropdownMenuShortcut>⌘2</DropdownMenuShortcut> */}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default TradeMenu;
